import ExportJsonExcel from 'js-export-excel';

let exportExcel = (sheetData, fileName) => {
    let sheetMap = {
        // 公共数据
        number: '编号',
        gather_channel: '采集渠道',
        first_follow_user: '首次跟进人员',
        first_follow_team: '首次跟进团队',
        first_followtime: '首次跟进时间',
        gathertime: '采集时间',
        category: '分类',

        // 客户数据
        name: '姓名',
        gather_way: '采集方式',
        expend_number: '扩展编号',
        gather_user: '采集人',
        dist_time: '派发时间',
        gender: '性别',
        age: '年龄',
        tel: '电话',
        father_tel: '父亲电话',
        mother_tel: '母亲电话',
        relative_tel: '亲戚电话',
        friend_tel: '朋友电话',
        is_tel: '是否有电话',
        wx: '微信',
        qq: 'qq',
        education: '学历',
        keyword: '关键词',
        search: '搜索词',
        in_school: '意向学校',
        in_major: '意向专业',
        nation: '民族',
        koseki: '户籍地',
        address: '居住地',
        area: '地区',
        remark: '采集备注',
        follow_team: '跟进团队',
        follow_user: '跟进人员',
        follow_team_property: '跟进团队性质',
        first_follow_team_property: '首次跟进团队性质',
        client_status: '客户状态',
        client_follow_status: '客户跟进状态',
        grade: '评级',
        ddRemark: '待定备注',
        wxRemark: '无效备注',
        followContent: '跟进记录',
        visit_result_iden: '转换结果',

        // 费用明细
        first_follow_disttime: '首次派发时间',
        close_cost: '结算成本',
        close_price: '结算价格',
        is_close: '是否结算',
        settlementtime: '结算时间'
    }

    let sheetFilter = Object.keys(sheetData[0])
    let sheetHeader = []
    sheetFilter.forEach(item => {
        sheetHeader.push(sheetMap[item])
    })

    let date = new Date()
    date = date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDay()
    fileName = date + fileName

    let toExcel = new ExportJsonExcel({
        fileName,
        datas: [
            {
                sheetData,
                sheetName: fileName,
                sheetFilter,
                sheetHeader,
            }
        ]
    })
    toExcel.saveExcel()

}

export { exportExcel }
